<template>
  <div class="home-about-item">
    <div class="home-item-left">
      <placed-image url="trees/hivepair.jpg" lazy />
    </div>
    <div class="home-item-right">
      <editable-item page="home" item="trees" :loaded="storiesLoaded" />
      <tree-counter />
      <div class="b-panel">
        <ix-router-link class="bigbutton" to='/ten-million-trees'>{{ $nippets.home.seeMore }}</ix-router-link>
      </div>
    </div>
    <div class="home-item-far-right">
      <div class="imblock">
        <img src="../../../assets/img/ten-million-trees.png" class="multiply" />
      </div>
      <div class="imblock">
        <a href="https://www.onepercentfortheplanet.org/" target="_blank"><img src="../../../assets/img/1pc_ftp.png" class="multiply" /></a>
      </div>
      <div class="imblock">
        <a href="https://www.weforest.org/"><img src="../../../assets/img/weforest.png" class="multiply" /></a>
      </div>
    </div>
  </div>
</template>

<script>
import PlacedImage from '@/components/widgets/PlacedImage.vue'
import EditableItem from '@/components/editors/EditableItem.vue'
import TreeCounter from '@/components/widgets/TreeCounter.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

import '@/css/home-about-item.css'

export default {
  mixins:[ ViewablePanel ],
  components:{
    PlacedImage,
    EditableItem,
    TreeCounter
  },
  data () {
    return {
      storiesLoaded: false
    }
    
  },
  methods: {
    async init () {
      this.$k.fetchStories('home', () => {
        this.storiesLoaded = true
      })
    }
  },
  watch: {
    seen () {
      this.init()
    }
  }
}
</script>